---
type: podcast
authors:
  - alex-patterson
  - brittney-postma
episode: 23
recording_date: March 18, 2022 2:00 PM
season: 2
published: published
podcast: CodingCat.dev
chapters_done: true
cloudinary_convert: false
cover: https://media.codingcat.dev/image/upload/main-codingcatdev-photo/routify.jpg
devto: https://dev.to/codingcatdev/223-routes-for-svelte-with-routify-4dcg
excerpt: Jake Rosenberg and Willow join us to talk about Routes for Svelte with Routify.
guests:
  - willow
  - jake-rosenberg
hashnode: https://hashnode.codingcat.dev/podcast-2-23-routes-for-svelte-with-routify
picks:
  [
    {
      author: 'alex-patterson',
      name: 'Open Source Alternative To',
      site: 'https://www.opensourcealternative.to/?ref=producthunt&category=Developer%20Tools'
    },
    {
      author: 'brittney-postma',
      name: 'Severance',
      site: 'https://tv.apple.com/us/show/severance/umc.cmc.1srk2goyh2q2zdxcx605w8vtx'
    },
    {
      author: 'brittney-postma',
      name: 'Sarah Drasner - DevX at Netlify',
      site: 'https://www.netlify.com/blog/2021/01/06/developer-experience-at-netlify/'
    }
  ]
slug: 2-23-routes-for-svelte-with-routify
sponsors:
  - builder-io
spotify: https://open.spotify.com/episode/5dBWRXsqsXJPlNwSRmAI1s?si=jHQuWoTVQpaJuh_7vD-nZg
start: June 8, 2022
title: Routes for Svelte with Routify
youtube: https://www.youtube.com/watch?v=AJ7hlCdZlDE
---

## Questions

1. Can you both give a brief introduction?
2. Why did you start Routify?
3. Is Routify just for Svelte?
4. What is the difference in routing between SK and Routify?
5. How does meta data differ from `svelte:head`
6. Routify 3 Public Beta
7. What are the differences between Routify 2 and 3?
8. Switching to Vite
9. How many maintainers are working on it?
10. What does Routify provide you?
